import { render, staticRenderFns } from "./AppSimpleTableWithApi3.vue?vue&type=template&id=25dc116f&scoped=true&"
import script from "./AppSimpleTableWithApi3.vue?vue&type=script&lang=js&"
export * from "./AppSimpleTableWithApi3.vue?vue&type=script&lang=js&"
import style0 from "./AppSimpleTableWithApi3.vue?vue&type=style&index=0&id=25dc116f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc116f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTooltip})
